module.exports = __webpack_public_path__ + "img/sharemail.ef091036.svg";